<template lang="html">
  <v-container
    grid-list-lg
    my-8
    fluid
  >
    <v-layout wrap>
      <v-flex
        v-bind="_pageLayout"
        mx-auto
      >
        <v-layout wrap>
          <v-flex
            xs12
            mb-4
            class="display-2 font-weight-light"
          >
            Super Info Consult
          </v-flex>
          <v-flex
            xs12
            v-html="page.html"
          />
          <v-flex>
            <v-btn
              color="primary"
              large
              depressed
              to="/services/bookings"
            >
              Book now
            </v-btn>
          </v-flex>
          <v-flex mt-8>
            <si-testimonials display-group-name="services" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import renderReady from '@/mixins/render-ready'
import { rtdb } from '@/plugins/firebase'


export default {
  mixins: [ renderReady ],
  data: () => ({
    page: {}
  }),
  computed: {
    ...mapGetters(['_pageLayout']),
    updated () {
      return this.page.updated 
          ? new Date(this.page.updated).toLocaleDateString()
          : ''
    }
  },
  beforeMount () {
    rtdb.ref('site/pages/consulting')
        .once('value')
        .then(s => this.page = s.val() || {})
  }
}
</script>

<style lang="css" scoped>

</style>
